import { combineReducers, applyMiddleware } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import thunk from "redux-thunk";
import storage from "redux-persist/lib/storage";
import { persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";
import { loginReducer } from "./Auth/Reducer";
import { LOGOUT } from "../Constants/AuthConstants";
import { setProfileId } from "./ProfileId/Reducer";

const persistConfig = {
	key: "root",
	storage: storage,
	blacklist: ["emailMembersData"],
};

const reducer = combineReducers({
	loginData: loginReducer,
	profileId: setProfileId,
});

const rootReducer = (state, action) => {
	if (action.type === LOGOUT) {
		localStorage.removeItem("persist:root");
		return reducer(undefined, action);
	}
	return reducer(state, action);
};

const emailData = {
	subject: "Email subject",
	content:
		"<h2><strong>Hello,</strong></h2><p><br></p><p>We need your participation in our fundraiser and we're using TeamWorks, an online platform that will help us</p><p>make more money.</p><p><a href='www.google.com' rel='noopener noreferrer' target='_blank' style='color: rgb(102, 185, 102);'>Click here</a> to join our fundraiser, so you can:</p><p><br></p><p>Share our page via email and social media.</p><p>Get credit for the money you raise.</p><p>Track your sales progress along the way.</p><p><br></p><p><strong>Note from your campaign manager:</strong></p><p><strong>﻿</strong></p><p>Hi All,</p><p>Please register for our fundraiser and promote our fundraising webpage to your friends, family and neighbors. Enter their email addresses using this site and pre-formatted email will be sent to them on your behalf. Make sure to include out of town contacts who would consider supporting you.</p><p><br></p><p><strong><em><u>Please contact me if you have any questions.</u></em></strong></p>",
};

const initialState = {
	loginData: {},
	emailMembersData: { emailData: emailData, members: [] },
	createdFundraiserData: {},
	salesOfficeData: {},
	campaignData: {},
	masterRepData: {},
	profileId: {},
};
const persistedReducer = persistReducer(persistConfig, rootReducer);
const middleware = [thunk];

const store = configureStore({
	reducer: persistedReducer,
	preloadedState: initialState,
	enhancers: [applyMiddleware(...middleware)],
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
			},
		}),
});
export default store;
